import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import api, { timeout } from "../../api"
import { setMessage } from "../message/messageSlice"

export const getUsers = createAsyncThunk(
  "generic/getUsers",
  async (
    { search, cursor, navigation, pagesize },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await api.get(
        `abide/v1/profile/users?search=${search}&cursor=${cursor}&navigation=${navigation}&page-size=${pagesize}`
      )
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)

export const getUserDetail = createAsyncThunk(
  "generic/getUserDetail",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.get(`abide/v1/profile/user/${id}`)

      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const getusersbasics = createAsyncThunk(
  "generic/getusersbasics",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`abide/v1/profile/actors`)
      return response?.data
    } catch (error) {
      return thunkAPI.rejectWithValue()
    }
  }
)

export const adduser = createAsyncThunk(
  "generic/adduser",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/profile/user/add", inputData)
      if (response) {
        toast.success("User added successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const edituser = createAsyncThunk(
  "generic/edituser",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post("abide/v1/profile/user/edit", inputData)
      if (response) {
        toast.success("User updated successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const deleteUser = createAsyncThunk(
  "generic/deleteUser",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v1/profile/user/delete/${id}`, {})
      if (response) {
        toast.success("User deleted successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const suspendActivativeUser = createAsyncThunk(
  "generic/suspendActivativeUser",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v1/profile/user/toggle`, inputData)
      if (response) {
        toast.success(`User ${inputData.status} successfully`, {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
export const forcePasswordReset = createAsyncThunk(
  "generic/forcePasswordReset",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.post(
        `abide/v1/profile/user/reset-password/${id}`,
        {}
      )
      if (response) {
        toast.success(`User password reset successfully`, {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const userRoles = createAsyncThunk(
  "generic/userRoles",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.get(`abide/v1/profile/roles`)
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      dispatch(setMessage(message))
      return rejectWithValue()
    }
  }
)

export const changerole = createAsyncThunk(
  "generic/changerole",
  async ({ inputData }, thunkAPI) => {
    try {
      const response = await api.post(`abide/v1/profile/user/role`, inputData)
      if (response) {
        toast.success("User role changed successfully!", {
          icon: "🎉",
        })
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)

export const getUploadedFile = createAsyncThunk(
  "generic/getUploadedFile",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.get(`abide/v2/document/document/${id}`)
      return response?.data
    } catch (error) {
      return thunkAPI.rejectWithValue()
    }
  }
)
export const uploadfile = createAsyncThunk(
  "generic/uploadfile",
  async ({ file }, { dispatch, rejectWithValue }) => {
    dispatch(uploadStart())
    try {
      let formdata = new FormData()
      formdata.append("file", file)
      const response = await api.post(`abide/v2/document/upload`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 300000,
        onUploadProgress: (progressEvent) => {
          const progress = Math.min(
            Math.round((progressEvent.loaded * 100) / progressEvent.total),
            99 // Cap progress at 99% until response is received
          )
          dispatch(uploadProgress(progress))
        },
      })
      if (response) {
        dispatch(uploadProgress(100))
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      dispatch(uploadFailure(message))
      return rejectWithValue()
    }
  }
)

export const updatedocument = createAsyncThunk(
  "generic/updatedocument",
  async ({ inputData }, { dispatch, rejectWithValue }) => {
    dispatch(uploadStart())
    try {
      let formdata = new FormData()
      formdata.append("file", inputData.file)
      formdata.append("key", inputData.id)

      const response = await api.post(`abide/v2/document/update`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 240000,
        onUploadProgress: (progressEvent) => {
          const progress = Math.min(
            Math.round((progressEvent.loaded * 100) / progressEvent.total),
            99 // Cap progress at 99% until response is received
          )
          dispatch(uploadProgress(progress))
        },
      })
      if (response) {
        dispatch(uploadProgress(100))
        return response?.data
      }
    } catch (error) {
      let message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      dispatch(setMessage(message))
      dispatch(uploadFailure(message))
      return rejectWithValue()
    }
  }
)
export const downloaddocument = createAsyncThunk(
  "generic/downloaddocument",
  async ({ id }, thunkAPI) => {
    try {
      const response = await api.get(`abide/v2/document/download/${id}`, {
        responseType: "blob",
      })
      return response?.data
    } catch (error) {
      let message =
        (error.response && error.response.data) ||
        error.message ||
        error.toString()
      if (error.message === `timeout of ${timeout}ms exceeded`) {
        message = "Response timeout, Retry"
      }
      if (error.message === "Network Error") {
        message = "Please check your network connectivity"
      }
      const newMessage =
        error.response && error.response.data.message
          ? error.response && error.response.data.message
          : error.response && error.response.data.error
          ? error.response && error.response.data.error
          : message
      toast.error(`${newMessage}`, {
        icon: "😱",
      })
      thunkAPI.dispatch(setMessage(newMessage))
      return thunkAPI.rejectWithValue()
    }
  }
)
const initialState = {
  users: null,
  file: null,
  progress: 0,
  isUploading: false,
  fileloading: false,
  documentloading: false,
  documentdownloaded: null,
  error: null,
  loading: false,
  detail: null,
  userbasics: null,
  govtagencies: null,
}

const genericSlice = createSlice({
  name: "generic",
  initialState,
  reducers: {
    uploadStart(state) {
      state.isUploading = true
      state.progress = 0
      state.error = null
    },
    uploadProgress(state, action) {
      state.isUploading = false
      state.progress = action.payload
    },
    uploadFailure(state, action) {
      state.isUploading = false
      state.error = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.pending, (state) => {
      state.loading = true
      state.users = null
    })
    builder.addCase(getUsers.fulfilled, (state, { payload }) => {
      state.loading = false
      state.users = payload.data
    })
    builder.addCase(getUsers.rejected, (state) => {
      state.loading = false
      state.users = null
    })
    builder.addCase(getUploadedFile.pending, (state) => {
      state.fileloading = true
      state.file = null
    })
    builder.addCase(getUploadedFile.fulfilled, (state, { payload }) => {
      state.fileloading = false
      state.file = payload.data
    })
    builder.addCase(getUploadedFile.rejected, (state) => {
      state.fileloading = false
      state.file = null
    })
    builder.addCase(downloaddocument.pending, (state) => {
      state.documentloading = true
      state.documentdownloaded = null
    })
    builder.addCase(downloaddocument.fulfilled, (state, { payload }) => {
      state.documentloading = false
      state.documentdownloaded = payload
    })
    builder.addCase(downloaddocument.rejected, (state) => {
      state.documentloading = false
      state.documentdownloaded = null
    })
    builder.addCase(uploadfile.fulfilled, (state, { payload }) => {
      state.file = payload.data
    })

    builder.addCase(getusersbasics.fulfilled, (state, { payload }) => {
      state.userbasics = payload?.data
    })
    builder.addCase(getUserDetail.fulfilled, (state, { payload }) => {
      state.detail = payload
    })
    builder.addCase(userRoles.fulfilled, (state, { payload }) => {
      state.roles = payload.data
    })
  },
})

export const { uploadStart, uploadProgress, uploadFailure } =
  genericSlice.actions

export default genericSlice.reducer
